export default __webpack_public_path__ + "static/media/sbj-chemistry.51f14fc9.svg";